export default __webpack_public_path__ + "static/media/1843.99f6ad35.png";